"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function UnderlineIcon(_a) {
    var _b = _a.height, height = _b === void 0 ? "14px" : _b, _c = _a.color, color = _c === void 0 ? "currentColor" : _c, style = _a.style;
    return (react_1.default.createElement("svg", { height: height, viewBox: "0 0 18 18", fill: "none", style: style, x: "0px", y: "0px" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("rect", { fill: color, x: "1", y: "14", width: "16", height: "2" }),
            react_1.default.createElement("path", { fill: color, d: "M4,2v6c0,2.8,2.2,5,5,5s5-2.2,5-5V2h-2v6c0,1.6-1.3,3-3,3c-1.6,0-3-1.4-3-3V2H4z" }))));
}
exports.default = UnderlineIcon;
//# sourceMappingURL=index.js.map